module.exports = __webpack_public_path__ + "img/portfolio-narazbor.783066b2.png";